'use client'

import React, { CSSProperties } from 'react'

import { Box } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import {
  buttonTagButtonBaseStyle,
  buttonTagContainerStyles,
} from './ButtonTag.styles'

export type ButtonTagProps = {
  /**
   * Theming contract shared by dark components. Defaults to 'dark'. The
   * legacy v1 chip used the same fixed palette in both schemes (white chip,
   * link-blue hover), carried here verbatim — reconcile when the rebrand
   * designs a tag chip.
   */
  colorScheme?: ColorScheme
  onClick?: () => void
  children?: React.ReactNode
  style?: CSSProperties
  lineHeight?: string
}

/**
 * Inline clickable tag chip (event references in resolution text).
 * Pixel-parity port of the web-app's Chakra v1 ButtonTag (ENG-31544).
 */
export const ButtonTag = ({
  // Accepted for the shared theming contract; the ported palette is
  // scheme-independent, matching the legacy component.
  colorScheme: _colorScheme = 'dark',
  onClick,
  children,
  style,
  lineHeight,
}: ButtonTagProps) => (
  // asChild: the Box styles merge onto a native <button> so the control
  // keeps real button semantics; the package has no bare chip primitive.
  <Box asChild lineHeight={lineHeight} {...buttonTagContainerStyles}>
    <button
      onClick={onClick}
      style={{ ...buttonTagButtonBaseStyle, ...style }}
      type='button'
    >
      {children}
    </button>
  </Box>
)
